export default {
  Intro: 'Hi there!',
  Title1: 'This link redirects to the',
  AppName: 'CareBase',
  Title2: 'app.',
  Subtitle: 'If the app did not open automatically, please install it on your device.',
};
